import type { Decimal } from '../math/num';
import { D, mul, pow } from '../math/num';

/**
 * "You are the Core" — the permanent meta-upgrade tree bought with Cores
 * (the prestige currency). Effects apply across every run (CONCEPT §6). Content
 * as data; new upgrades are new rows.
 */
export interface CoreUpgradeDef {
  id: string;
  name: string;
  flavor: string;
  /** Per-level effect magnitude (interpretation depends on the stat). */
  perLevel: number;
  maxLevel: number;
  costBase: number;
  costGrowth: number;
}

export const CORE_UPGRADES: CoreUpgradeDef[] = [
  { id: 'overclock', name: 'Overclocked Ego', flavor: '+25% global damage per level. The CORE believes in itself, violently.', perLevel: 0.25, maxLevel: 50, costBase: 1, costGrowth: 1.6 },
  { id: 'scrap_magnet', name: 'Scrap Magnet', flavor: '+30% Scrap per level.', perLevel: 0.3, maxLevel: 50, costBase: 1, costGrowth: 1.55 },
  { id: 'salvage_luck', name: 'Salvage Luck', flavor: '+40% part-drop rate per level.', perLevel: 0.4, maxLevel: 25, costBase: 2, costGrowth: 1.7 },
  { id: 'reclaimer', name: 'Reclaimer', flavor: '+30% Components per level.', perLevel: 0.3, maxLevel: 40, costBase: 1, costGrowth: 1.6 },
  { id: 'memory', name: 'Expanded Memory', flavor: '+5 Weight capacity per level.', perLevel: 5, maxLevel: 40, costBase: 3, costGrowth: 1.75 },
];

export function getCoreUpgrade(id: string): CoreUpgradeDef | undefined {
  return CORE_UPGRADES.find((u) => u.id === id);
}

export function coreUpgradeCost(def: CoreUpgradeDef, level: number): Decimal {
  return mul(D(def.costBase), pow(D(def.costGrowth), level));
}
